import { render, staticRenderFns } from "./FloorEventsPanel.vue?vue&type=template&id=3984b675&scoped=true"
import script from "./FloorEventsPanel.vue?vue&type=script&lang=js"
export * from "./FloorEventsPanel.vue?vue&type=script&lang=js"
import style0 from "./FloorEventsPanel.vue?vue&type=style&index=0&id=3984b675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984b675",
  null
  
)

export default component.exports